import { Component } from '@theme/component';

class UgcVideo extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.video = this.querySelector('video');
    this.preview = this.refs.preview;
    this.playBtn = this.refs.playBtn;
    this.pauseBtn = this.refs.pauseBtn;
    this.muteBtn = this.refs.muteBtn;
    this.controls = this.refs.controls;

    if (!this.video) return;
    this.video.muted = true;

    this.video.addEventListener('loadedmetadata', () => {
      const dur = this.refs.duration;
      if (!dur) return;
      const total = Math.round(this.video.duration);
      if (total >= 60) {
        const min = Math.floor(total / 60);
        const sec = total % 60;
        dur.textContent = sec > 0 ? `${min}min${sec}s` : `${min}min`;
      } else {
        dur.textContent = `${total}sec`;
      }
    });
  }

  play() {
    if (!this.video) return;
    if (this.preview) this.preview.style.display = 'none';
    this.video.play();
    if (this.controls) this.controls.style.display = 'flex';
    this._playing = true;
  }

  handleVideoClick() {
    if (!this._playing) return;
    this.togglePause();
  }

  togglePause() {
    if (!this.video) return;
    if (this.video.paused) {
      this.video.play();
      if (this.pauseBtn) this.pauseBtn.dataset.paused = 'false';
    } else {
      this.video.pause();
      if (this.pauseBtn) this.pauseBtn.dataset.paused = 'true';
    }
    // Le nom du bouton décrit l'action disponible.
    const btn = this.pauseBtn;
    if (btn) btn.setAttribute('aria-label', (this.video.paused ? btn.dataset.labelPlay : btn.dataset.labelPause) || '');
  }

  toggleMute() {
    if (!this.video) return;
    this.video.muted = !this.video.muted;
    if (this.muteBtn) {
      this.muteBtn.dataset.muted = this.video.muted ? 'true' : 'false';
      this.muteBtn.setAttribute('aria-label', (this.video.muted ? this.muteBtn.dataset.labelUnmute : this.muteBtn.dataset.labelMute) || '');
    }
  }
}

customElements.define('ugc-video', UgcVideo);
